// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"08733427","41":"0aea8d6b","190":"60841d93","451":"23612c18","827":"95cc4638","846":"2b5faaa8","918":"d754d1cd"}[chunkId] + ".js";
};